import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
Vue.use(Router)
import router from './routers.js'
import '@/assets/global.less' /*引入公共样式*/

// import vConsole from 'vconsole'
// Vue.prototype.$vConsole = new vConsole()



// 基础组件的自动化全局注册。全局注册的行为必须在根 Vue 实例 (通过 new Vue) 创建之前发生
import './components/index'
import VueToast from './common/toast/index.js';
Vue.use(VueToast);


Vue.prototype.openUrl=function (url) {
	this.$router.push({path:url})
}

const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
